<template>
  <b-checkbox
    v-bind="$attrs"
    v-on="$listeners"
    v-model="innerValue"
    :native-value="nativeValue"
    :true-value="trueValue"
    :false-value="falseValue"
  >
    <slot
      v-for="slotName in Object.keys($slots)"
      :name="slotName"
      :slot="slotName"
    />
  </b-checkbox>
</template>
<script>
export default {
  name: 'CCheckbox',
  props: {
    value: [String, Number, Boolean, Function, Object, Array, Symbol],
    nativeValue: [String, Number],
    trueValue: {
      type: [Object, String, Number],
      defalut: 'true'
    },
    falseValue: {
      type: [Object, String, Number],
      defalut: 'false'
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox {
  /deep/ input[type='checkbox'] + .check {
    border-radius: 2px;
    font-size: 10px;
    transition: none;
  }
  &.is-small {
    /deep/ input[type='checkbox'] + .check {
      border-radius: 2px;
    }
  }
  /deep/ .control-label {
    line-height: 1.2;
  }
}
</style>
